<template >
  <div>
    <div class="col-12" style="padding: 0" v-if="refresh">
      <div class="row ml-0 mr-0 mb-2 mt-2">
        <div class="w-100">
          <div
            class="tabulator direct-invst-table"
            ref="activeDiligenceTbl"
            style="width: 100%; height: 100%"
          ></div>
        </div>
      </div>
    </div>
    <dialogconfirmcompany
      v-model="dialogDataConfirmCompany"
    ></dialogconfirmcompany>
    <DiligencePortfolio
      @save-refresh="NoteColorsave"
      @cancel-refresh="tabulatorRefresh"
      v-model="dialogInvest"
    ></DiligencePortfolio>
    <DialogStageNote
      v-model="dialogStageNote"
      @cancel-refresh="tabulatorRefresh"
      @new-stage-added="newStageAdded"
    ></DialogStageNote>
    <el-dialog
      center
      title="Archive item?"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      width="750px"
      style="margin: 0 auto"
      :visible.sync="confirmMdlShow"
      @close="
        isSaving = false;
        confirmMdlShow = false;
      "
      class="team-modal col-lg-12 col-sm-12 col-12 col-md-12"
    >
      <div class="card-body">
        <div class="inputs row">
          <p style="width: 100%; text-align: center">
            Are you sure you want to archive this item?
          </p>
        </div>
        <div class="actionbuttons">
          <button
            @click.prevent="
              confirmMdlShow = !confirmMdlShow;
              isSaving = false;
            "
            class="todo-form-cancel-button btn-outline-secondary"
          >
            Cancel
          </button>
          <button
            class="todo-form-submit-button btn btn-primary"
            style="height: 35px"
            :disabled="isSaving"
            @click="archiveMethod"
          >
            Yes
            <b-spinner v-if="isSaving" small label="Spinning"></b-spinner>
          </button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Tabulator from "tabulator-tables";
import moment from "moment";
import { mapGetters } from "vuex";
import { Select, Option, Dialog } from "element-ui";
import { stageSelect } from "./investments";
import api from "../../../axios_api";
import DiligencePortfolio from "../Dialogs/DiligencePortfolio";
import DialogConfirmCompany from "../Dialogs/DialogConfirmCompany";
import DialogStageNote from "../Dialogs/DialogStageNote";
import config from "../../../../config/settings";
const DATA_STATUS_CONFIRMED = "Confirmed";
const DATA_STATUS_UNCONFIRMED = "Unconfirmed";
const DATA_STATUS_UPDATING = "Retrieving";
export default {
  computed: {
    ...mapGetters("diligence", ["activeDiligenceData"]),
    ...mapGetters("diligence_stage", ["diligenceStageData"]),
    ...mapGetters("workspacePlans", ["feature", "plan"]),
    ...mapGetters("role", ["getCurrentWorkspaceRolePermissions", "checkRole"]),
    customizedWorkflows() {
      let featureIndex = this.feature.findIndex((item) => {
        if (item == "CUSTOMIZED_WORKFLOWS") return item;
      });
      if (featureIndex >= 0) return true;
      else return false;
    },
    addStage() {
      let featureIndex = this.getCurrentWorkspaceRolePermissions.findIndex(
        (item) => {
          if (item.toLowerCase() == "ADD STAGE".toLowerCase()) return item;
        }
      );
      if (featureIndex >= 0) return true;
      else return false;
    },
    diligenceStage() {
      let stageData = [];
      this.diligenceStageData.map((item) => {
        if (item.stage_name) {
          let json = {};
          json.label = item.stage_name;
          json.value = item.stage_name;
          stageData.push(json);
        }
      });
      if (this.customizedWorkflows && this.addStage) {
        stageData.push({
          value: "Add",
          label: '<i class="fas fa-plus"></i> Add stage',
          disabled: true,
        });
      }
      let featureIndex = this.getCurrentWorkspaceRolePermissions.findIndex(
        (item) => {
          if (item.toLowerCase() == "ADD INVESTMENT".toLowerCase()) return item;
        }
      );
      if (featureIndex < 0) {
        stageData = stageData.filter(
          (item) => item.value.toLowerCase() != "invest"
        );
      }
      return stageData;
    },
    diligenceDetails() {
      let self = this;
      let data = JSON.parse(JSON.stringify(self.activeDiligenceData));
      data.map((item, index) => {
        if (item.deal_stage) {
          let stageName = self.diligenceStageData.find(
            (stage) => stage._id == item.deal_stage
          );
          item.stageObj = stageName;
          if (stageName) {
            //item.dealStageName = `<div style="height:25px;background-color:${stageName.color}"  title = "${stageName.stage_name}" class="badge invest-badge px-3">${stageName.stage_name}</div>`;
            item.dealStageName = stageName.stage_name;
          }
        }
        item.logo_url = item.logo_url
          ? item.logo_url
          : "static/img/generic-logo.png";
        item.id = index;
        let logoUrl = this.getImageUrl(item.logo_url);
        if (item.data_status == DATA_STATUS_CONFIRMED) {
          item.nameLogoString = `
                <div class="d-flex">
                    <img src="${logoUrl}" style="width: 35px;height: 35px;border-radius: 50%;" class="company-img"/>
                    <img src="static/img/confirmed.svg" class="company-statys-img"/>
                            <b style="margin-left: 48px;">${item.name}  </b> 
                </div>

            `;
        }
        if (item.data_status == DATA_STATUS_UNCONFIRMED) {
          item.nameLogoString = `
                <div class="d-flex">
                    <img src="${logoUrl}" style="width: 35px;height: 35px;border-radius: 50%;" class="company-img"/>
                    <img src="static/img/warning.svg" class="company-statys-img"/>
                            <b class="ml-5">${item.name} </b> 
                </div>
            `;
        }
        if (item.data_status == DATA_STATUS_UPDATING) {
          item.nameLogoString = `
                <div class="d-flex">
                    <img src="${logoUrl}" style="width: 35px;height: 35px;border-radius: 50%;" class="company-img"/>
                    <img src="static/img/retrieving.svg" class="company-statys-img"/>
                            <b class="ml-5">${item.name} </b> 
                </div>
            `;
        }
      });
      data.sort((a, b) => {
        return new Date(b.created) - new Date(a.created);
      });
      return {
        data: JSON.parse(JSON.stringify(data)),
        columns: this.tableColumns,
      };
    },
    tableColumns() {
      const self = this;

      let stageEditor = function (
        cell,
        onRendered,
        success,
        cancel,
        editorParams
      ) {
        try {
        } catch (err) {
          console.log(err);
        }
      };
      return [
        {
          title: "Company",
          field: "nameLogoString",
          sorter: function (a, b, aRow, bRow, column, dir, sorterParams) {
            let first = aRow.getData().name || "";
            let second = bRow.getData().name || "";
            return first.localeCompare(second);
          },
          resizable: true,
          tooltip: false,
          formatter: "html",
          cellClick: function (e, cell) {
            if (
              [DATA_STATUS_CONFIRMED, DATA_STATUS_UPDATING].indexOf(
                cell.getData()["data_status"]
              ) == -1
            ) {
              return;
            }
            // set the 'current company' and go to the company profile
            let name = cell.getData().name;
            // get the ucid
            let ucid = _.reduce(
              self.activeDiligenceData,
              (memo, data) => {
                if (data.name == name) return data.ucid;
                return memo;
              },
              -1
            );
            // save our current company and go to the profile page
            self.$store.commit("temp/currentCompany", ucid);
            self.$router.push(
              `/${self.$route.params.account_id}/${self.$route.params.workspace_id}/companyProfile/${ucid}`
            );
          },
        },
        {
          title: "Round",
          sorter: "string",
          field: "stage",
          resizable: true,
          editable: function (cell) {
            let featureIndex = self.getCurrentWorkspaceRolePermissions.findIndex(
              (item) => {
                if (
                  item.toLowerCase() == "CHANGE DILIGENCE ROUND".toLowerCase()
                )
                  return item;
              }
            );
            if (featureIndex >= 0) return true;
            else return false;
          },
          editor: "select",
          editorParams: { values: stageSelect },
        },
        {
          title: "Diligence Stage",
          field: "dealStageName",
          sorter: "string",
          resizable: true,
          editable: function (cell) {
            let featureIndex = self.getCurrentWorkspaceRolePermissions.findIndex(
              (item) => {
                if (
                  item.toLowerCase() == "CHANGE DEAL FLOW STAGE".toLowerCase()
                )
                  return item;
              }
            );
            if (featureIndex >= 0) return true;
            else return false;
          },
          tooltip: false,
          editor: "select",
          editorParams: {
            values:
              self.diligenceStageSelect && self.diligenceStageSelect.length > 0
                ? self.diligenceStageSelect
                : self.diligenceStage,
          },
          //formatter: "html",
          formatter: function (cell, formatterParams) {
            let data = cell.getData();
            let stageName = data.stageObj;
            return `<div style="height:25px;background-color:${stageName.color}"  title = "${stageName.stage_name}" class="badge invest-badge px-3">${stageName.stage_name}</div>`;
          },
        },

        {
          headerSort: false,
          resizable: false,
          sorter: "number",
          responsive: 3,
          width: "20",
          visible: false,
          formatter: function (cell, formatterParams) {
            if (
              cell.getData()["isDeleting"] &&
              cell.getData()["isDeleting"] == true
            )
              return '<i class="nc-icon nc-refresh-02 spinner"></i>';
            else return `<i class="far fa-trash-alt"></i>`;
          },
          cellClick: function (e, cell) {
            self.deleteItem = cell.getData();
            self.confirmMdlShow = true;
          },
        },
        {
          title: "created",
          field: "created",
          sorter: "string",
          download: true,
          visible: false,
        },
        {
          minWidth: 30,
          resizable: false,
          headerSort: false,
          responsive: 0,
          formatter: function (cell, formatterParams) {
            let name = cell.getData().name;
            return `<img src="static/img/Archive.svg" title="Archive ${name}" style="opacity:0.5"></i>`;
            // return `<i class="fas fa-trash-alt" style="color: #7D7D7D;"></i>`;
          },
          cellClick: function (e, cell) {
            self.diligenceEdit = cell.getData();
            self.confirmMdlShow = true;
          },
        },
      ];
    },
  },
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    [Dialog.name]: Dialog,
    [DialogConfirmCompany.name]: DialogConfirmCompany,
    DiligencePortfolio,
    DialogStageNote,
  },
  data() {
    return {
      title: `Add Diligence`,
      tabulator: null,
      isSaving: false,
      confirmMdlShow: false,
      deleteItem: {},
      tempData: null,
      diligenceEdit: {},
      refresh: true,
      investModel: false,
      portfolioInfo: {},
      organization: "",
      dialogDataConfirmCompany: {
        isShow: false,
      },
      dialogInvest: {
        isShow: false,
        data: {},
        isCreate: true,
      },
      dialogStageNote: {
        isShow: false,
        data: {},
        newStage: false,
        title: "",
        context: "Active",
      },
      index: 0,
      oldEditData: {},
      diligenceStageSelect: [],
    };
  },
  mounted() {
    let self = this;
    this.diligenceEdit = {};
    this.checkDataStatus();
    self.tabulator = new Tabulator(self.$refs.activeDiligenceTbl, {
      layout: "fitColumns",
      index: "_id",
      tooltips: true,
      data:
        this.diligenceDetails && this.diligenceDetails.data
          ? this.diligenceDetails.data
          : [],
      columns: self.diligenceDetails.columns,
      tooltips: true,
      pagination: "local",
      paginationSize: 20,
      paginationSizeSelector: true,
      placeholder: "No records to view",
      cellEdited: function (cell) {
        self.index = cell.getRow().getData().id;
        let row = _.reduce(
          cell._cell.row.cells,
          (m, c) => {
            if (c.column.field == "_id" || c.column.field == cell.getField())
              m[c.column.field] = c.getValue();
            return m;
          },
          {}
        );
        self.diligenceEdit = row;
        let data = cell.getData();
        self.diligenceEdit = { ...self.diligenceEdit, ...data };
        self.isSaving = false;
        if (cell.getValue() == "Add" && cell.getField() == "dealStageName") {
          self.dialogStageNote = {
            isShow: true,
            data: self.diligenceEdit,
            newStage: true,
            title: "Add Diligence Stage",
            context: "Active",
          };
        } else if (
          cell.getField() == "dealStageName" &&
          cell.getValue() == "Invest"
        ) {
          self.portfolioInfo = cell.getData();
          self.isSaving = false;
          self.title = "Invest Note";
          self.organization = self.diligenceEdit.organization;
          self.portfolioInfo.initial_investment = new Date();
          self.dialogInvest = {
            data: { row, portfolio: self.portfolioInfo },
            isShow: true,
          };
        } else if (
          cell.getField() == "dealStageName" &&
          cell.getValue() == "Pass"
        ) {
          self.dialogStageNote = {
            isShow: true,
            data: self.diligenceEdit,
            newStage: false,
            title: "Why Pass?",
            context: "Active",
          };
        } else if (cell.getField() == "dealStageName") {
          self.dialogStageNote = {
            isShow: true,
            data: self.diligenceEdit,
            newStage: false,
            title: "Add Note",
            context: "Active",
          };
        } else {
          row = self.diligenceEdit;
          self.$store
            .dispatch("diligence/apiPatchDiligenceInst", row)
            .then((data) => {
              self.organization = row.organization;
              self.sendDiligenceNotifications("round", row);
              self.$store.dispatch("portfolio/_apiFetchPortfolio");
            });
          if (!_.isNil(self.tempData)) {
            self.tabulator.replaceData(self.tempData);
            self.tempData = null;
          }
        }
      },
      cellEditing: function (cell) {
        self.oldEditData = JSON.parse(JSON.stringify(cell.getData()));
      },
      rowClick: function (e, row) {
        let data = JSON.parse(JSON.stringify(row.getData()));
        data._id = data.portfolio_item;
        if (row.getData().data_status == DATA_STATUS_UNCONFIRMED) {
          self.openConfirmCompany(data);
          e.preventDefault();
          return false;
        }
      },
    });
  },
  watch: {
    diligenceStageData: {
      handler: function (newData) {
        this.diligenceStageSelect = this.diligenceStage;
      },
    },
    activeDiligenceData: function (data) {
      let self = this;
      self.tabulator.updateData(self.diligenceDetails.data);
      if (this.tabulator && !this.diligenceEdit.hasOwnProperty("_id")) {
        self.diligenceDetails.data.map((item) => {
          let row = self.tabulator.getRow(item._id);
          if (!row) self.tabulator.addData([item], true);
        });
        if (window.sessionStorage.getItem("diligence_id")) {
          self.tabulator.deleteRow(
            window.sessionStorage.getItem("diligence_id")
          );
          window.sessionStorage.removeItem("diligence_id");
        }
      }
    },
  },
  methods: {
    archiveMethod() {
      let self = this;
      self.isSaving = true;
      let payload = {};
      let url = "";
      payload._id = self.diligenceEdit._id;
      payload.is_archive = true;
      self.$store
        .dispatch("diligence/apiPatchDiligenceInst", payload)
        .then((data) => {
          self.tabulator.deleteRow(self.diligenceEdit._id);
          let row = JSON.parse(JSON.stringify(self.diligenceEdit));
          row.stage = "Rejected";
          self.sendDiligenceNotifications("stage", row);
          self.isSaving = false;
          self.confirmMdlShow = false;
        })
        .catch((err) => {
          self.isSaving = false;
          self.$toaster.error("Fail to update the stage.");
        });
    },
    sendDiligenceNotifications(type, diligenceData) {
      if (this.checkRole && this.checkRole.toLowerCase() == "collaborator") {
        diligenceData.account_id = this.$route.params.account_id;
        diligenceData.workspace_id = this.$route.params.workspace_id;
        diligenceData.organization = this.organization;
        this.$store.dispatch("notifications/apiDiligenceCollaboratorReceipt", {
          type,
          diligenceData,
        });
      }
    },
    deleteMethod() {
      if (this.deleteItem) {
        this.isSaving = true;
        let self = this;
        let data = this.deleteItem;
        let ucid = data.ucid;
        let _id = data._id;
        api
          .delete(
            `${self.$route.params.account_id}/${self.$route.params.workspace_id}/company/investment/${ucid}`
          )
          .then((data) => {})
          .catch((err) => {});
        return self.$store
          .dispatch(`diligence/apiDeleteDiligence`, {
            ucid: ucid,
            _id: _id,
          })
          .then((data) => {
            return self.$store
              .dispatch("people/removeCompany", {
                ucid: ucid,
              })
              .then((res) => {
                return self.$store.dispatch(
                  "diligence/apiDeleteDiligenceReferrs",
                  { _id: _id }
                );
              })
              .then((data) => {
                return self.$store.dispatch("file/removeCompany", {
                  ucid: ucid,
                });
              })
              .then((res) => {
                // delete all attachments
                return self.$store.dispatch("attachment/removeCompany", {
                  ucid: ucid,
                });
              })
              .then((res) => {
                // delete all attachments
                return self.$store.dispatch("investment/removeCompany", {
                  ucid: ucid,
                });
              })
              .then((res) => {
                return self.$store.dispatch("portfolio/apiDeletePortfolio", {
                  ucid: ucid,
                  _id: _id,
                });
              })
              .then((res) => {
                return self.$store.dispatch("diligence/apiCleanFetchDiligence");
              })
              .then((res) => {
                return self.$store.dispatch("referrer/start");
              })
              .then((res) => {
                // done, company should be erased, go back
                self.tabulator.deleteRow(_id);
                self.isSaving = false;
                self.confirmMdlShow = false;
                self.$toaster.success("Deleted Successfuly.");
              })
              .catch((err) => {
                console.error(
                  `Error during delete process, aborting... ${err}`
                );
                self.isSaving = false;
                self.confirmMdlShow = false;
                // go back to investments
              });
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        this.isSaving = false;
      }
    },
    checkDataStatus() {
      let check = false;
      for (let i = 0; i < this.activeDiligenceData.length; i++) {
        if (
          this.activeDiligenceData[i]["data_status"] == DATA_STATUS_UPDATING
        ) {
          check = true;
          break;
        }
      }
      if (check) {
        window.sessionStorage.setItem("diligenceCheck", true);
        let timeGap = 5000;
        let count = [];
        if (!window.sessionStorage.getItem("loopDiligenceCheck")) {
          let timeInterval = setInterval(() => {
            window.sessionStorage.setItem("loopDiligenceCheck", true);
            api
              .get(
                `${this.$route.params.account_id}/${this.$route.params.workspace_id}/diligence`
              )
              .then((resp) => {
                window.sessionStorage.setItem("loopDiligenceCheck", true);

                let data = JSON.parse(
                  JSON.stringify(resp.data.encrypt.dilignceData)
                );
                this.$store.commit(
                  "diligence/merge",
                  resp.data.encrypt.dilignceData
                );
                let checkLength = 0;
                let checkCount = 0;
                let array = [];
                if (window.sessionStorage.getItem("diligenceCheck")) {
                  array = data.filter((item) => {
                    if (item.data_status == DATA_STATUS_UPDATING) {
                      checkCount++;
                      return item;
                    }
                  });
                  if (array.length > 0) {
                    checkLength = 1;
                  }
                  count.push(checkCount);
                  if (checkLength == 0) {
                    count = [];
                    if (window.sessionStorage.getItem("loopDiligenceCheck")) {
                      window.sessionStorage.removeItem("loopDiligenceCheck");
                    }
                    if (this.tabulator) {
                      let activeDiligenceData = this.diligenceDetails.data;
                      this.tabulator.updateData(activeDiligenceData);
                    }
                    clearInterval(timeInterval);
                  } else {
                    if (count.length > 1) {
                      count = [];
                      if (count[count.length - 1] != count[count.length - 2]) {
                        if (this.tabulator) {
                          let activeDiligenceData = this.diligenceDetails.data;
                          this.tabulator.updateData(activeDiligenceData);
                        }
                      }
                    }
                  }
                } else {
                  clearInterval(timeInterval);
                }
              })
              .catch((err) => {
                clearInterval(timeInterval);
              });
          }, timeGap);
        }
      }
    },
    openConfirmCompany(data) {
      this.dialogDataConfirmCompany = {
        isShow: true,
        data: data,
      };
    },
    NoteColorsave() {
      let self = this;
      self.isSaving = true;
      let payload = {};
      let url = "";
      if (self.title == "Invest Note") {
        let stageItem = self.diligenceStageData.find(
          (item) => item.stage_name == self.diligenceEdit.dealStageName
        );
        payload.passedNotes = "Invested";
        payload.deal_stage = stageItem._id;
        payload._id = self.diligenceEdit._id;
        url = "diligence/apiStatusUpdate";
      }
      self.$store
        .dispatch(url, payload)
        .then((data) => {
          self.tabulator.deleteRow(self.diligenceEdit._id);
          let row = self.diligenceEdit;
          self.sendDiligenceNotifications("stage", row);
          self.isSaving = false;
        })
        .catch((err) => {
          self.isSaving = false;
          self.$toaster.error("Fail to update the stage.");
        });
    },
    tabulatorRefresh() {
      this.colors = "#FFCCBCFF";
      this.colorPickerModel = false;
      if (this.oldEditData && this.oldEditData._id)
        this.tabulator.updateData([this.oldEditData]);
    },
    newStageAdded() {
      this.$parent.$parent.$parent.suggestionRefresh = false;
      setTimeout(() => {
        this.$parent.$parent.$parent.suggestionRefresh = true;
      }, 1500);
    },
    getImageUrl(image) {
      if (!image) {
        return;
      }
      // image.includes(
      //  "https://res-3.cloudinary.com/crunchbase-production/image/upload"
      //) ||
      if (
        image.includes(config.CRUNCHBASE_IMAGE_URL) ||
        image.includes("https://res") ||
        image.includes("static/img/generic-logo.png")
      ) {
        return image;
      }
      let imageId = image.slice(image.lastIndexOf("t_api_images/") + 13);
      if (!imageId || imageId.length == 0) {
        return image;
      }
      return `${config.CRUNCHBASE_IMAGE_URL}/${imageId}`;
    },
  },
};
</script>
<style>
.active-diligence-table .card-body {
  padding-top: 0px;
}
</style>